import React from "react";
import PropTypes from "prop-types";
import PharmGKBInternal from "../../../../../components/PharmGKB/PharmGKBInternal";

const PharmGKBDrugDatabase = ({ result }) => {
  return (
    <div className="varsome-result-fixed" id="pharmGKB-drug-database">
      <div className="varsome-container varsome-container__basic">
        <PharmGKBInternal result={result} isGene={true} />
      </div>
    </div>
  );
};
PharmGKBDrugDatabase.propTypes = {
  result: PropTypes.shape(),
};

PharmGKBDrugDatabase.defaultProps = {
  result: null,
};

export default PharmGKBDrugDatabase;
